class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tab = this.querySelectorAll(".tab-title");
    this.tabContents = this.querySelector(".tabs-contents");
    this.tabContent = this.querySelectorAll(".tab-content");
    this.link = this.querySelectorAll(".toggleLink");
    this.readMore = this.querySelectorAll("[data-show-more-toogle]");
    this.tabClose = this.querySelectorAll(".pdViewTab-close");
    this.isVerticalPopup = this.dataset.vertical === "sidebar";
    this.isVerticalSidebarMobile =
      this.dataset.verticalMobile === "sidebar-mobile";

    for (let i = 0; i < this.tab.length; i++) {
      this.tab[i].addEventListener("click", this.tabActive.bind(this));
    }

    for (let i = 0; i < this.link.length; i++) {
      this.link[i].addEventListener("click", this.tabToggle.bind(this));
    }

    document.addEventListener("click", (e) => {
      if (
        e.target.matches("[data-show-more-toogle]") ||
        e.target.closest("[data-show-more-toogle]")
      ) {
        this.readMoreReadLess(e);
      } else if (
        e.target.matches(".pdViewTab-close") ||
        e.target.closest(".pdViewTab-close")
      ) {
        this.productTabClose(e);

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
          this.handleVerticalPopupClose(e);
        }
      }
    });

    if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
      document
        .querySelector(".background-overlay")
        .addEventListener("click", this.onBackgroundClick.bind(this));
    }

    setTimeout(() => {
      if (window.innerWidth > 550) {
        const $thisContent = this.querySelector('.toggle-content[product-description-tab]');

        if (!$thisContent) return;

        const tabShowMore = $thisContent.querySelector(".tab-showMore");
        if (!tabShowMore) return;

        const tabHeight = $thisContent.offsetHeight;
        const maxHeight = parseInt(tabShowMore.dataset.desMax);

        if (tabHeight < maxHeight) {
          tabShowMore.remove();
        }
      }
    });
  }

  tabActive(event) {
    event.preventDefault();
    event.stopPropagation();

    var $this = event.target,
      id = $this.getAttribute("href").replace("#", ""),
      button_tab = document.querySelector(".an-horizontal-shaking");

    if (!$this.classList.contains("is-open")) {
      this.tab.forEach((element, index) => {
        element.classList.remove("is-open");
      });

      $this.classList.add("is-open");
      this.tabContents.classList.add("is-show");
      button_tab?.classList.add("open-tab-content");

      this.tabContent.forEach((element, index) => {
        if (element.getAttribute("id") == id) {
          element.classList.add("is-active");
        } else {
          element.classList.remove("is-active");
        }
      });
    }

    if ($this.classList.contains("open-tab-content")) {
      button_tab?.classList.remove("open-tab-content");
    }

    this.checkTabShowMore(id);
  }

  closeOtherTabs(currentLink, currentContent) {
    this.link.forEach((link) => {
      const content = link.parentNode?.nextElementSibling;
      if (!content) return;

      if (link !== currentLink) {
        link.classList.remove("is-open");
        content.classList.remove("is-show");
        content.classList.remove("is-active");
        content.style.display = "none";
      }
    });
  }

  tabToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const $this = event.currentTarget;
    const $thisContent = $this.parentNode.nextElementSibling;

    if (!$thisContent) return;

    const isPopupMobile =
      $this.classList.contains("popup-mobile") && window.innerWidth <= 551;

    const isSidebarMode =
      (this.isVerticalPopup && window.innerWidth > 550) ||
      ($this.classList.contains("sidebar-mobile") && window.innerWidth <= 550);

    const isShowMobile =
      window.innerWidth <= 551 && $this.classList.contains("show-mobile");

    const isOpen =
      $this.classList.contains("is-open") ||
      $thisContent.classList.contains("is-show") ||
      window.getComputedStyle($thisContent).display !== "none";

    if (isOpen) {
      $this.classList.remove("is-open");

      if (isPopupMobile || isSidebarMode) {
        $thisContent.classList.remove("is-show");
        document.body.classList.remove("tab-popup-show");
        document.body.classList.remove("tab-popup-sidebar-show");
      } else {
        $($thisContent).stop(true, true).slideUp("slow");
      }

      return;
    }

    this.closeOtherTabs($this, $thisContent);

    $this.classList.add("is-open");

    if (isPopupMobile || isSidebarMode) {
      $thisContent.classList.add("is-show");
      document.body.classList.add("tab-popup-show");

      if (isSidebarMode) {
        document.body.classList.add("tab-popup-sidebar-show");
      }
    } else if (isShowMobile) {
      $($thisContent).stop(true, true).slideDown("slow");
    } else {
      $($thisContent).stop(true, true).slideDown("slow");
    }
  }
}

customElements.define("product-tab", ProductTabs);